import { render } from "./ScreeningQuestions.vue?vue&type=template&id=429e2afd&scoped=true"
import script from "./ScreeningQuestions.vue?vue&type=script&lang=js"
export * from "./ScreeningQuestions.vue?vue&type=script&lang=js"

import "./ScreeningQuestions.vue?vue&type=style&index=0&id=429e2afd&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429e2afd"]])

export default __exports__